export function dollarFormatter(amount: any) {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
  });
  return `$${formatter.format(amount)}`;
}
